<div
    class="ft-image-div ft-profile-pic"
    [class]="resolvedUrl() ? '' : silhouetteClass()"
    [style.background-image]="resolvedUrl() ? 'url(' + resolvedUrl() + ')' : null"
></div>
